import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";

import { useOnClickOutside } from "../../../services/hooks";
import { createAction } from "../../../utils/sagaHelper";
import { WAITER_TYPES } from "../../../utils/enums";

import Waiter from "../Waiter/Waiter";
import IconButton from "../IconButton";
import { getTranslateTitle } from '../../../utils/objects-util.js';

const EditItemControl = ({ t, item, value, onLayoutOpen, itemAction, history }) => {
    const [open, setOpen] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(null);
    const targetRef = useRef();

    const handleOnAction = action => {
        return new Promise((resolve, reject)=> {
            if(action) {
                if(action.action) {
                    itemAction(action.action, item).then(()=> {
                        resolve();
                    }, ()=> reject());
                } else if(action.link) {
                    resolve();

                    if(action.isLayout) {
                        onLayoutOpen && onLayoutOpen(action.link(item));
                    } else {
                        history.push(action.link(item));
                    }                    
                }
            } else {
                reject();
            }
        });
    }

    const onEditControlClick = () => {
        return new Promise(resolve=> {
            resolve();
            setOpen(!open);
        });
    }

    const handleOnActionClick = action => {
        if(action.isConfirm) {
            setConfirmOpen(action);
        } else {
            handleOnAction(action);
        }
    }

    const handleOnConfirm = () => {
        return new Promise((resolve, reject)=> {
            handleOnAction(confirmOpen).then(()=> {
                resolve();
                setConfirmOpen(null);
                setOpen(false);
            }, ()=> reject());
        });
    }

    const handleOnCancel = () => {
        setConfirmOpen(null);
    }

    useOnClickOutside(targetRef, () => {
        setOpen(false);
        setConfirmOpen(null);
    });
    
    return (
        <div className={classNames("editItemControl")} ref={targetRef}>
            <IconButton isIcon={true} iconName={"editControl"} onClick={onEditControlClick} />
            {open && value && !confirmOpen && (
                <div className={classNames("actions")}>
                    {value.map(action=> (
                        <div key={`action-${action.title}`} className={classNames("action")} onClick={()=> handleOnActionClick(action)}>
                            {getTranslateTitle(action.title)}
                        </div>
                    ))}
                </div>
            )}
            {confirmOpen && (
                <div className={classNames("confirmContainer")}>
                    <button className={classNames("btn", "denied")} onClick={handleOnCancel}>
                        {t("basic.CANCEL_BUTTON")}
                    </button>
                    <Waiter type={WAITER_TYPES.button} useClass={classNames("btn", "confirm")}
                        stopPropagation={true}
                        spanText={t("basic.OK_BUTTON")}
                        handleOnClick={handleOnConfirm}
                    />                    
                </div>
            )}
        </div>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        itemAction: (action, data) => dispatch(createAction(action, data))
    };
};

export default withRouter(connect(null, mapDispatchToProps)(
    withTranslation()(EditItemControl)
));